export default __webpack_public_path__ + "static/media/end_call.7ffb3874.svg";